"use client";
import Image from "next/image";
import { useTranslations } from "use-intl";

export default function MainAbout() {
  const t = useTranslations("Home");

  return (
    <section>
      <div className="mt-8 flex flex-col xl:flex-row xl:items-center gap-10 xl:gap-16">
        <div className="relative w-full max-w-300 xl:max-w-175 min-h-75 sm:min-h-87.5 md:min-h-175 xl:min-h-150 shrink-0">
          <Image
            src="/main-about.png"
            alt="about image"
            fill
            className="object-cover rounded-2xl"
          />
        </div>
        <div className="flex-1">
          <h4 className="mb-3 text-dark font-semibold text-sm sm:text-base">
            {t("about")}
          </h4>

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 leading-snug text-main">
            {t("welcome")}
          </h2>

          <p className="text-[#606060] text-sm sm:text-base leading-8 tracking-wide text-start">
            {t("aboutDes")}
          </p>
        </div>
      </div>
    </section>
  );
}
